import React from 'react'
import Svg, {
  Defs,
  LinearGradient,
  Stop,
  Text,
  type SvgProps,
} from 'react-native-svg'

type Props = {
  size?: number
} & Omit<SvgProps, 'width' | 'height'>

export const SplashLogo = React.forwardRef(function SplashLogoImpl(
  props: Props,
  ref,
) {
  const {size = 200, ...rest} = props
  const center = size / 2
  const fontSize = size * 0.25

  return (
    <Svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      {...rest}
      // @ts-ignore
      ref={ref}>
      <Defs>
        {/* Gradient for text - blue/cyan to purple/magenta */}
        <LinearGradient id="shxreGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <Stop offset="0%" stopColor="#00D9FF" stopOpacity="1" />
          <Stop offset="50%" stopColor="#8B5CF6" stopOpacity="1" />
          <Stop offset="100%" stopColor="#EC4899" stopOpacity="1" />
        </LinearGradient>
      </Defs>

      {/* SHXRE text - rings removed, keeping just the text with gradient */}
      <Text
        x={center}
        y={center + fontSize * 0.35}
        fontSize={fontSize}
        fontWeight="600"
        fill="url(#shxreGradient)"
        textAnchor="middle"
        fontFamily="system-ui, -apple-system, sans-serif">
        SHXRE
      </Text>
    </Svg>
  )
})

